const moment = require('moment');
import {
	IGoalDataPoint,
	maxDatapointAgeForDaysLeft
} from '../../Entity/IGoalDataPoint';

export function IsDatapointRelevant(
	datapoint: IGoalDataPoint,
	goalStartDate: string
) {
	const isRelevant =
		moment().diff(moment(datapoint.lastmodifiedtime).local(), 'days') <=
			maxDatapointAgeForDaysLeft &&
		moment(datapoint.lastmodifiedtime)
			.local()
			.diff(goalStartDate, 'minutes') >= 0;

	return isRelevant;
}
